import Vue from 'vue'

const preventReClick = Vue.directive('preventReClick', {
    inserted: function (el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 3000)
            }
        })
    }
});

export { preventReClick }

// export default {
//   install (Vue) {
//     // 防重复点击(指令实现)
//     Vue.directive('preventReClick', {
//       inserted (el, binding) {
//         el.addEventListener('click', () => {
//           if (!el.disabled) {
//             el.disabled = true
//             setTimeout(() => {
//               el.disabled = false
//             }, binding.value || 3000)
//           }
//         })
//       }
//     })
//   }
// }


// WEBPACK FOOTER //
// ./src/utils/preventReClick.js